import { Button } from "@9amhealth/shared";
import type { FC } from "react";
import {
  PARTNER_CONFIGS,
  openPartnerContinueUrl
} from "src/constants/partnerConfig";
import type { KnownPartnerSources } from "src/constants/partner";
import Translate from "../Translate/Translate";

/**
 * "Continue with <partner>" button shared by LoginOptions and the partner
 * reauth screens. Renders nothing if the partner's continue-URL resolver
 * has nothing to link to (e.g. Transcarent's env-configured SSO link missing).
 */
const ContinueWithPartnerButton: FC<{
  partner: KnownPartnerSources;
  center?: boolean;
}> = ({ partner, center }) => {
  const config = PARTNER_CONFIGS[partner];
  if (!config) {
    return null;
  }

  const Icon = config.icon;

  return (
    <Button
      center={center}
      theme="charcoal"
      hideArrow={true}
      outline={true}
      icon={<Icon />}
      onPress={() => openPartnerContinueUrl(config)}
    >
      <span style={{ fontWeight: "500" }}>
        <Translate
          msg="login"
          variables={{ context: config.loginTranslateContext }}
          noWrap
        />
      </span>
    </Button>
  );
};

export default ContinueWithPartnerButton;
